<div class="example-container">
  @if (loading) {
    <div class="example-loading-shade">
      <mat-spinner diameter="70" color="accent"></mat-spinner>
    </div>
  }
  <div class="table-container example-table-container {{loading ? 'loading' : ''}}">
    <ng-content select="[mat-table]"></ng-content>
  </div>
  <ng-content select="[paginator]"></ng-content>
</div>
